import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Login',
    meta: { pageTitle: "Zaloguj się", title: 'Zaloguj się' },
    component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
  },
  {
    path: '/hub',
    name: 'Hub',
    meta: { pageTitle: "Panel - Jawgarden", title: 'Hub' },
    component: () => import(/* webpackChunkName: "Hub" */ '../views/Hub.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard.vue'),
    children: [
      {
        path: 'users',
        component: () => import(/* webpackChunkName: "ManageUsers" */ '../views/ManageUsers.vue'),
        meta: { pageTitle: "Zarządzaj użytkownikami - Jawgarden", title: 'Zarządzaj użytkownikami systemu', subtitle: 'Przeglądaj, edytuj i konfiguruj konta użytkowników oraz ich uprawnienia.' }
      },
      {
        path: 'user',
        component: () => import(/* webpackChunkName: "ShowUserDetails" */ '../views/ShowUserDetails.vue'),
        meta: { pageTitle: "Szczegóły konta - Jawgarden", title: 'Szczegóły konta', subtitle: 'Przeglądaj szczegóły konta użytkownika, w tym jego dane, role i uprawnienia.' }
      },
      {
        path: 'clients',
        component: () => import(/* webpackChunkName: "ManageClients" */ '../views/ManageClients.vue'),
        meta: { pageTitle: "Zarządzaj klientami - Jawgarden", title: 'Zarządzaj klientami systemu', subtitle: 'Przeglądaj, edytuj i konfiguruj profile klientów.' }
      },
      {
        path: 'client',
        component: () => import(/* webpackChunkName: "ShowClientDetails" */ '../views/ShowClientDetails.vue'),
        meta: { pageTitle: "Szczegóły konta - Jawgarden", title: 'Szczegóły klienta', subtitle: 'Przeglądaj szczegóły konta klienta, w tym jego dane.' }
      },
      {
        path: 'products',
        component: () => import(/* webpackChunkName: "ManageProducts" */ '../views/ManageProducts.vue'),
        meta: { pageTitle: "Produkty - Jawgarden", title: 'Produkty', subtitle: 'Przeglądaj, edytuj i konfiguruj produkty dostępne w systemie.' }
      },
      {
        path: 'panel',
        component: () => import(/* webpackChunkName: "ManageEmployees" */ '../views/CreateSummaries.vue'),
        meta: { pageTitle: "Zarządzaj panelem - Jawgarden", title: 'Zarządzaj panelem', subtitle: 'Przeglądaj, edytuj i konfiguruj panel pracowników.' }
      },
      {
        path: 'summaries',
        component: () => import(/* webpackChunkName: "ManageEmployees" */ '../views/ManageSummaries.vue'),
        meta: { pageTitle: "Zarządzaj zestawieniami - Jawgarden", title: 'Zarządzaj zestawieniami', subtitle: 'Przeglądaj, edytuj i konfiguruj zestawienia dostępne w systemie.' }
      },
      {
        path: 'settlement',
        component: () => import(/* webpackChunkName: "ManageEmployees" */ '../views/ManageSummariesAdmin.vue'),
        meta: { pageTitle: "Rozliczenie zestawień - Jawgarden", title: 'Rozlicz zestawienia', subtitle: 'Przeglądaj i rozlicz zestawienia dostępne w systemie.' }
      },
      {
        path: 'summary',
        component: () => import(/* webpackChunkName: "ShowSummaryDetails" */ '../views/ShowSummaryDetails.vue'),
        meta: { pageTitle: "Szczegóły zestawienia - Jawgarden", title: 'Szczegóły zestawienia', subtitle: 'Przeglądaj szczegóły zestawienia, w tym jego dane i status.' }
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const authIsReady = !!store.state.authIsReady
  const user = store.state.user
  const isLoginRoute = to.path === '/'

  if (!authIsReady) {
    next()
    return
  }

  if (!user && !isLoginRoute) {
    next('/')
    return
  }

  if (user && isLoginRoute) {
    next('/hub')
    return
  }

  next()
})

export default router
